import React, { useState } from "react";
import styles from "./EditCategory.module.css";
import step from "../../../assets/step2.png";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../components/input/InputField";
import Button from "../../../components/button/Button";
import { List } from "antd";
import { useTranslation } from "react-i18next";
import TextArea from "antd/es/input/TextArea";

function JobDetails() {
  const inventories = [
    {
      id: 1,
      name: "Paper Towel",
      quantity: 3,
    },
    {
      id: 2,
      name: "Mop",
      quantity: 0,
    },
    {
      id: 3,
      name: "Wiper",
      quantity: 2,
    },
    {
      id: 4,
      name: "Bucket",
      quantity: 4,
    },
    {
      id: 5,
      name: "Brush",
      quantity: 1,
    },
  ];

  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const data = state
  console.log('data', data)
  const renderInventoriesItem = (item) => {
    return (
      <div className={styles.flexC}>
        <text className={styles.radio_title}>{item?.name}</text>
        <text className={styles.radio_title}>{item?.quantity}</text>
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <div className={styles.flex}>
        <h1 className={styles.heading}>{t("Edit Job Details")}</h1>
        <img src={step} className={styles.step_image} />
      </div>
      <InputField
        label={t("Service Name")}
        value={data?.service_name}
        // rightIcon={true}
        disabled={true}
      />
      <div style={{ marginBottom: '5px' }}>
        <text className={styles.label} >Service Details</text>
      </div>
      <TextArea
        label={t("Service Details")}
        value={data?.details}
        rows={4}
        style={{ resize: 'none', backgroundColor: 'transparent', border: '1px solid white', color: 'white',padding:'15px',fontSize:'15px' }}
        disabled={true}
      />


      {data?.inventories ?
        <>
          <InputField value={t("Store")} disabled={true} arrow={true} />
          <List dataSource={data?.inventories} renderItem={renderInventoriesItem} />
        </>
        : null
      }


      <div className={styles.button}>
        <Button
          text={t("Next")}
          onClick={() => navigate("/WorkOrderRequest/CreateChecklist", { state: data })}
        />
      </div>
    </div>
  );
}

export default JobDetails;
